import z from 'zod';
import { createAnalyticsSchema, createCustomAnalyticsSchema } from '../factory';
export var AnalyticsDataSchema = createAnalyticsSchema({
    path: z.string(),
    message: z.string(),
    type: z.string(),
    data: z.any(),
});
export var CustomAnalyticsDataSchema = createCustomAnalyticsSchema;
